import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { photoTagsApi } from 'src/Services/API';
import { CreatePhotoTagDto, TaggedMemberDto } from 'src/Services/API/generated';

export const useAddPhotoTag = (
  options?: UseMutationOptions<TaggedMemberDto, unknown, CreatePhotoTagDto>
) => {
  const queryClient = useQueryClient();

  return useMutation<TaggedMemberDto, unknown, CreatePhotoTagDto>(
    'add-photo-tag',
    async (data: CreatePhotoTagDto) => {
      const response = await photoTagsApi.photoTagsControllerAddTag(data);
      return response.data;
    },
    {
      ...options,
      onSuccess(data, variables, context) {
        queryClient.invalidateQueries(['fetch-photo-tags', variables.storageFileId]);
        queryClient.invalidateQueries(['fetch-member-photo-album', data.memberId]);

        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
